const game = {
  state: {
    //游戏信息
    gameInfo: {
      name: "",
      id: ""
    },
    //公共头部展示的title
    title: "",
    //设置重置ID
    resetId: []
  },
  mutations: {
    //设置游戏的信息
    SET_GAME: (state, gameInfo) => {
      state.gameInfo = gameInfo;
    },
    //设置公共头部展示的title
    SET_TITLE: (state, title) => {
      state.title = title;
    },
    //设置重置ID
    SET_RESET_ID: (state, resetId) => {
      state.resetId = resetId;
    }
  },
  actions: {
    SetGame({ commit }, gameInfo) {
      commit("SET_GAME", gameInfo);
    },
    SetTitle({ commit }, title) {
      commit("SET_TITLE", title);
    },
    SetResetId({ commit }, resetId) {
      commit("SET_RESET_ID", resetId);
    }
  }
};

export default game;
